<template>
  <footer id="contact-us">
    <div class="footer-menus">
        <div class="contact-us">
          <p class="menu-title">解决方案</p>
          <ul class="menu-item">
            <li><a href="#" v-on:click="solution('ITInfrastructure')">企业IT基础架构服务</a></li>
            <li><a href="#" v-on:click="solution('customization')">定制化解决方案服务</a></li>
            <li><a href="#" v-on:click="solution('ProcessAutomation')">智能数据与流程自动化</a></li>
            <li><a href="#" v-on:click="solution('ITO')">ITO资源外包服务</a></li>
          </ul>
        </div>
        <div class="service-menu footer-menu">
          <p class="menu-title">成功案例</p>
          <ul class="menu-item">
            <li><a href="#" v-on:click="successCases('AzureImplementation')">Azure项目实施</a></li>
            <li><a href="#" v-on:click="successCases('ADDomain')">AD域部暑与升级</a></li>
            <li><a href="#" v-on:click="successCases('Office365Deployment')">Office 365部署与迁移</a></li>
            <li><a href="#" v-on:click="successCases('Microsoft365Security')">MIcrosoft 365 信息安全</a></li>
          </ul>
        </div>
        <div class="service-menu footer-menu">
          <p class="menu-title" v-on:click="aboutUs()" style="cursor: pointer;">关于众诚</p>
        </div>
        <div class="service-menu footer-menu">
          <p class="menu-title">联系我们</p>
          <ul class="menu-item">
            <li><a href="#">电话：18688864104</a></li>
            <li><a href="#">邮箱：Business@we-trust.com.cn</a></li>
            <li><a href="#">地址：广州市天河区黄埔大道西76号富力盈隆广场11楼1108</a></li>
          </ul>
        </div>
        <p class="rights">@2025 广州众诚科技有限公司版权所有 <a href="https://beian.miit.gov.cn" target="_blank" style="color:white;">粤ICP备2023023669号-1</a></p>
        <div class="scrollToTop">
          <a href=""><i class="fas fa-chevron-up"></i></a>
        </div>
      </div>
  </footer>
</template>

<script>
export default {
  name: "foot-aside",
  components: {},
  methods: {
    aboutUs() {
      this.$router.push('/about')
    },
    solution(tabName) {
      this.$router.push('/solution#' + tabName)
    },
    successCases(tabName) {
      this.$router.push('/successCases#' + tabName)
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/layout/component/foot-aside.vue